/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { SubmissionQuestionBase } from 'bundles/grading/api/types';

import QuestionShell from './QuestionShell';

type Props = {
  questions: SubmissionQuestionBase[];
};

const styles = {
  container: () => css`
    margin: 0 0 var(--cds-spacing-300) 0;
  `,
};

const QuestionSummary: React.FC<Props> = ({ questions }) => {
  return (
    <div>
      {questions.map((question) => (
        <div css={styles.container} key={question.formElementNodeId}>
          <QuestionShell key={question.formElementNodeId} question={question} />
        </div>
      ))}
    </div>
  );
};

export default QuestionSummary;
